module.exports = __webpack_public_path__ + "static/img/seahorse.70ca432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/collage/papercuts/seahorse.jpg
// module id = gbOI
// module chunks = 1